import { ApplicationInsights } from '@microsoft/applicationinsights-web'

const appInsights = new ApplicationInsights({
    config: {
        // eslint-disable-next-line no-undef
        connectionString: fundraisingConfig.appInsightsConnectionString
    }
});
appInsights.loadAppInsights();
appInsights.trackPageView();